export default "__VITE_ASSET__wIr0n8M$__"